import {
  sendGetHttpRequest,
  sendPostHttpRequest,
  sendHttpRequest,
} from "lib/fetcher";
import { API_URL } from "lib/constants";
export async function getLicenseOrders(limit: number, offset: number) {
  return sendGetHttpRequest(
    `${API_URL}/order/orders?paging.limit=${limit}&paging.offset=${offset}`,
  );
}

export async function getLicenseOrdersDetail(orderId: number, orgId?: string) {
  return sendGetHttpRequest(`${API_URL}/order/orders/${orderId}`, orgId);
}

export async function getGoods(goodType: string) {
  return sendGetHttpRequest(`${API_URL}/goods?goodsType=${goodType}`);
}

export async function cancelOrder(orderId: number, orgId?: string) {
  return sendPostHttpRequest(`/order/orders/${orderId}/cancel`, {}, orgId);
}

export async function getMoreCredits(orgId?: string) {
  return sendPostHttpRequest(`/license/ai/request`, {}, orgId);
}

export async function refundOrder(orderId: number, orgId?: number) {
  return sendPostHttpRequest(`/order/orders/${orderId}/revoke`, {}, orgId);
}

export function getCustomers(params: string) {
  return sendHttpRequest({
    method: "get",
    url: `/user/customers?${params}`,
  });
}
